/**
 * Homepage: The Time Slides (TTS) — Slick + progress.
 */
(function ($) {
  'use strict';
  $(function () {
    $('#TTS_Slides').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: '#TTS_NavDots',
                        autoplay: true,
                        autoplaySpeed: 7000,
                        infinite:true,
                        centerMode: true,
                        responsive: [
                            {
                                breakpoint: 750,
                                settings: {
                                    centerMode: false,
                                    centerPadding: '0px',
                                    adaptiveHeight: true
                                }
                            }
                        ]
                    });
                    (function () {
                        var $ttsSlides = $('#TTS_Slides');
                        function ttsSlickReflow() {
                            if ($ttsSlides.hasClass('slick-initialized')) {
                                $ttsSlides.slick('setPosition');
                            }
                        }
                        $ttsSlides.find('img').each(function () {
                            var img = this;
                            if (img.complete) {
                                return;
                            }
                            $(img).one('load', ttsSlickReflow);
                        });
                        $(window).on('resize', function () {
                            if (window.innerWidth < 750) {
                                ttsSlickReflow();
                            }
                        });
                        setTimeout(ttsSlickReflow, 0);
                    })();
                    $('#TTS_NavDots').slick({
                        infinite:false,
                        slidesToShow: 10,
                        asNavFor: '#TTS_Slides',
                        dots: false,
                        centerMode: false,
                        centerPadding: '60px',
                        vertical: true,
                        verticalSwiping: true,
                        focusOnSelect: true,
                    });
    
    
                    /*slickSliderExample.on('before', function (event, slick, currentSlide) {
                        // Check the current slide index and change autoplaySpeed accordingly
                        if (currentSlide === 2) {
                            // Change autoplaySpeed for the third slide
                            slickSliderExample.slick('slickSetOption', 'autoplaySpeed', 10000);
                        } else {
                            // Other slides
                            slickSliderExample.slick('slickSetOption', 'autoplaySpeed', 2000);
                        }
                    });*/
    
    
                    var slideDurationsMs = [7000, 7000, 7000];
                    var tickMs = 10;
                    var percentTime = 0;
                    var activeSlideIndex = 0;
                    var isPausedByUser = false;
                    var pausedToggleIndex = null;
                    var theTick;
    
                    function getActiveBar() {
                        return $('#TTS_NavDots .TTS_ND_Tab').eq(activeSlideIndex).find('.ND_Progress');
                    }
    
                    function getActiveMobileProgressFill() {
                        var $fill = $('#TTS_Slides .slick-slide.slick-active:not(.slick-cloned) .TTS_MobileStep.is-active .TTS_MobileBar__fill');
                        if (!$fill.length) {
                            $fill = $('#TTS_Slides .slick-slide.slick-active .TTS_MobileStep.is-active .TTS_MobileBar__fill').first();
                        }
                        return $fill;
                    }
    
                    function getActiveProgressElements() {
                        return getActiveBar().add(getActiveMobileProgressFill());
                    }
    
                    function getCurrentDurationMs() {
                        return slideDurationsMs[activeSlideIndex] || 7000;
                    }
    
                    function resetProgressbar() {
                        $('#TTS_NavDots .ND_Progress').css({ height: '0%' });
                        $('#TTS_Slides .TTS_MobileBar__fill').css({ height: '0%' });
                        clearInterval(theTick);
                    }
    
                    function startProgressbar() {
                        resetProgressbar();
                        percentTime = 0;
    
                        if (isPausedByUser) {
                            getActiveProgressElements().css({ height: '100%' });
                            $('#TTS_Slides').slick('slickPause');
                            return;
                        }
    
                        theTick = setInterval(theInterval, tickMs);
                        $('#TTS_Slides').slick('slickPlay');
                    }
    
                    function pauseProgressbar(clickedIndex) {
                        isPausedByUser = true;
                        pausedToggleIndex = clickedIndex;
                        clearInterval(theTick);
                        getActiveProgressElements().css({ height: '100%' });
                        $('#TTS_Slides').slick('slickPause');
                    }
    
                    function resumeProgressbar() {
                        if (!isPausedByUser) {
                            return;
                        }
    
                        isPausedByUser = false;
                        pausedToggleIndex = null;
                        clearInterval(theTick);
                        theTick = setInterval(theInterval, tickMs);
                        $('#TTS_Slides').slick('slickPlay');
                    }
    
                    function theInterval() {
                        var currentDurationMs = getCurrentDurationMs();
                        var activeEls = getActiveProgressElements();
    
                        percentTime += (tickMs / currentDurationMs) * 100;
                        activeEls.css({ height: percentTime + '%' });
    
                        if (percentTime >= 100) {
                            $("#TTS_Slides").slick('slickNext');
                        }
                    }
    
                    startProgressbar();
    
                    $("#TTS_Slides").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                        activeSlideIndex = nextSlide;
                        startProgressbar();
                    });
    
                    $("#TTS_NavDots").on("click", ".TTS_ND_Title", function() {
                        var clickedIndex = parseInt($(this).closest('.TTS_ND_Tab').attr('data-slick-index'), 10);
                        if (isNaN(clickedIndex)) {
                            clickedIndex = $(this).closest('.TTS_ND_Tab').index();
                        }
    
                        if (isPausedByUser) {
                            if (clickedIndex === pausedToggleIndex) {
                                resumeProgressbar();
                            } else {
                                pausedToggleIndex = clickedIndex;
                            }
                        } else {
                            pauseProgressbar(clickedIndex);
                        }
                    });
    
                    $("#TTS_Slides").on("click", ".TTS_MobileStep", function() {
                        if (window.innerWidth >= 750) {
                            return;
                        }
    
                        var clickedIndex = $(this).index();
                        if (clickedIndex < 0) {
                            return;
                        }
    
                        $('#TTS_Slides').slick('slickGoTo', clickedIndex);
    
                        if (isPausedByUser) {
                            if (clickedIndex === pausedToggleIndex) {
                                resumeProgressbar();
                            } else {
                                pausedToggleIndex = clickedIndex;
                                pauseProgressbar(clickedIndex);
                            }
                        } else {
                            pauseProgressbar(clickedIndex);
                        }
                    });
  });
})(jQuery);
